import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import "./index.css";
import App from "./App";
import { reduxStore } from "./api/reduxStore";
import "./i18n";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* Redux Provider — RTK Query -fetchille (backend-tukipyynnöt, K6). */}
    <ReduxProvider store={reduxStore}>
      <App />
    </ReduxProvider>
  </StrictMode>,
);
